import { TmsEventType } from '../DataLayer.types';
import BaseEventNoPayload from './BaseEventNoPayload';
export default class SwitchToListEvent extends BaseEventNoPayload {
    constructor() {
        super();
        this.tmsEventType = TmsEventType.link;
        this.eventName = 'plp switch to list';
    }
}
//# sourceMappingURL=SwitchToListEvent.js.map